import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useLoading } from '../context/LoadingContext';

const NavigationLoader = () => {
    const { setPageLoading } = useLoading();
    const location = useLocation();

    useEffect(() => {
        // Only show loader if the transition takes more than 100ms
        const showTimer = setTimeout(() => {
            setPageLoading(true);
        }, 100);

        // Hide loader after a short period OR we could let individual pages hide it
        // For now, let's keep it brief for navigation feedback
        const hideTimer = setTimeout(() => {
            setPageLoading(false);
        }, 600);

        return () => {
            clearTimeout(showTimer);
            clearTimeout(hideTimer);
            setPageLoading(false);
        };
    }, [location.pathname, setPageLoading]);

    return null;
};

export default NavigationLoader;
